import React from 'react'

export const StateLabel = ({ state, className }: { state?: string; className?: string }) => {
  if (!state) return null
  if (state === 'activated') return null
  return <span className={`badge badge-${state} ${className}`}>{i18n.t(`misc.state_labels.${state}`)}</span>
}
